import React from 'react';
import styled from 'styled-components';
import control from '../../../vendor/react-validation/hocs/control';

import definitions from '../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../Style/cssHelpers';

const Select = ({ error, isChanged, fullWidth, isUsed, ...props }) => {
    return (
        <SelectWrapper fullWidth={fullWidth} isInvalid={isChanged && isUsed && error}>
            <select {...props} />
            {isChanged && isUsed && error}
        </SelectWrapper>
    );
}

const SelectWrapper = styled.div`
    width: 100%;

    select {
        min-width: 200px;
        width: ${props => props.fullWidth ? '100%' : 'auto'};
        height: 46px;
        padding: 12px 13px 11px;
        margin-bottom: ${props => props.marginBottom ? props.marginBottom : '10px'};

        border-radius:2px;
        background: ${definitions.colors.grayBackground};
        border:solid 1px ${props => props.isInvalid ? definitions.colors.error : definitions.colors.grayBorder};

        -webkit-appearance: none;
        -moz-appearance: none;
        cursor: pointer;

        background-image: url('/images/arrows.svg');
        background-position: right 15px;
        background-size: 30px 20px;
        background-repeat: no-repeat;

        font-size:18px;
        line-height:1.2;
        color: ${definitions.colors.grayText};

        &:disabled {
            cursor: not-allowed;
            opacity: 0.5;
        }

        ${mediaQuery.medium(`
            height: 44px;
            font-size: 16px;
            background-position: bottom 10px right 5px;
        `)}

        ${mediaQuery.small(`
            font-size: 13px;
            background-position: bottom 4px right 0px;
            background-size: 15px 15px;

            height: 29px;
            padding: 0 10px 0 10px;
        `)}


    }

    select.is-invalid-input {
        border: 1px solid ${definitions.colors.error};
        margin-bottom: 0px;
    }
`;

export default control(Select);
